module.exports = {
  INVALID_PROCESSING_HOUR: {
    message: 'Processing hour outside allowed range, we process billets until 7:00pm'
  },
  IS_AFTER_DUE_DATE_ERROR_MESSAGE: {
    message: 'Payment date can not be after due date'
  },
  INVALID_BARCODE: {
    message: 'Invalid barcode'
  },
  MAX_VALUE: {
    message: 'Value greater than allowed, we support until (R$ 250.000,00)'
  },
  INVALID_VALUE: {
    message: 'Value not allowed'
  },
  EXPIRED_DUE_DATE: {
    message: 'Billet expired'
  },
  BUSINESS_DAY: {
    message: 'We process billets only on business days, you need to change the date to a business day'
  },
  DUPLICATED_BARCODE: {
    message: 'Duplicated barcode'
  },
  PAYMENT_DATE_IS_REQUIRED: {
    message: 'Payment date is required'
  },
  PAYMENT_DATE_WRONG_DATE: {
    message: 'Wrong format to payment date'
  },
  PAYMENT_DATE_BEFORE_CURRENT_DATE: {
    message: 'Payment date before current date'
  },
  BATCH_WITHOUT_BILLETS: {
    message: 'Your batch has no billets, register billets to close it'
  },
  FORMAT_ERROR: {
    message: 'Wrong format of a billet field content'
  },
  DUPLICATED_INTEGRATION_ID: {
    message: 'Duplicated integration id'
  },
  KEEPING_BALANCE_FOR_TOO_LONG: {
    message: 'You can not schedule a billet after 30 days'
  },
  MIN_VALUE: {
    message: 'Billet value must be greater than R$0,00'
  },
  INVALID_BARCODE_OR_DIGITABLE_LINE: {
    message: 'Billet barcode or digitable line are invalid'
  },
  BILLET_NOT_REGISTERED: {
    message: 'Billet not registered'
  },
  BILLET_NOT_FOUND_FOR_CONSULTATION: {
    message: 'Could not find billet'
  },
  BILLET_EXCEEDED_DEADLINE: {
    message: 'Billet exceeded the payment deadline'
  },
  BILLET_ALREADY_PAID_CANT_CONSULT: {
    message: 'Billet has already been paid, it is not possible to consult'
  },
  BILLET_AVAILABLE_FOR_PAYMENT: {
    message: 'Billet available for payment'
  },
  CANT_SCHEDULE_OVERDUE_BILLET: {
    message: "Can't schedule payment of overdue billets"
  },
  CONSULT_REQUIRED_FOR_BILLETS: {
    message:
      'To pay overdue billets or billets with discount it is mandatory that you first consult the billet data in our API. This way we guarantee the correct amount, updated with fines, interest and discounts. See our documentation for more details'
  },
  MAX_DECIMAL_PLACES: {
    message: 'Billet value can not exceed 2 decimal places'
  }
};
